import React, { useState, useCallback, useEffect } from "react";
import * as AppActions from "../stores/app/actions";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {useNavigate} from 'react-router-dom';
import styled from "styled-components";
import Fader from "../components/Fader"
import RFPInfoDrawer from "../components/rfp/RFPInfoDrawer"
import greenAlertIcon from "./../assets/greenAlertIcon.svg";
import { BodyLoadingSpin } from "../components/styled";
import spinIcon from "../assets/greySpinIcon.svg";
import { Footer } from "react-components-core-pcca";
import { TRANSACTION_STATE } from '../constants/status';
import { isRfpPending } from "../utils/common";

import boaImage from "../assets/rfpBankImages/boa.png"
import capitalOneImage from "../assets/rfpBankImages/capitalOne.png"
import chaseImage from "../assets/rfpBankImages/chase.png"
import citiImage from "../assets/rfpBankImages/citi.png"
import genericImage from "../assets/rfpBankImages/generic.png"
import pncImage from "../assets/rfpBankImages/pnc.png"
import tdImage from "../assets/rfpBankImages/td.png"
import usBankImage from "../assets/rfpBankImages/usBank.png"
import wellsFargoImage from "../assets/rfpBankImages/wellsFargo.png"

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 24px 0 24px;
`;

const ApprovalBody = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: left;
  color: rgba(0, 0, 0, 0.54);
  padding-top: 84px;
  padding-bottom: 12px;
`;

const InstructionsContainer = styled.div`
  display: flex;
  padding-bottom: 24px;
`;

const InstructionsBody = styled.div`
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: left;
  color: #009245;
`;

const InstructionsIcon = styled.img`
  margin-top: auto;
`;

const BankImage = styled.img`
  width: 100%;
  padding-bottom: 30px;
`;

const FooterWrapper = styled.div`
  margin-top: auto;
  padding-bottom: 65px;
`;

const StyledBodyLoadingSpin = styled(BodyLoadingSpin)`
  height: unset;
  padding-bottom: 8px;
`
const StyledSpinIcon = styled.img`
  height: 24px;
`;
const ReturnText = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color: rgba(0, 0, 0, 0.54);
  padding-bottom: 24px;
`;

const RFPLitePage = () => {
  const appStore = useSelector((state) => state, shallowEqual).app;
  const { merchantName, transactionType, transactionAmount, bankName, transactionState, rfpError } = appStore;
  const [showInfoDrawer, setShowInfoDrawer] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rfpStatusInterval = 2000;

  const handleOBVFlow = useCallback(
    (status) => {
      switch (status) {
        case TRANSACTION_STATE.NONE:
          return dispatch(
            AppActions.transactionStatus(),
          );
        case TRANSACTION_STATE.PAYMENT_PROCESSING:
          return true;
        case TRANSACTION_STATE.SUCCESS:
          return navigate("/rfpSuccess");
        case TRANSACTION_STATE.FAILED:
          return navigate(`/rfpError/${rfpError}`);
        default:
          return true;
      }
    },
    [navigate, dispatch, rfpError],
  );

  useEffect(() => {
    handleOBVFlow(transactionState);
  }, [transactionState, handleOBVFlow]);


  // Fetch the transaction status in two second intervals
  useEffect(() => {
    if (transactionState === TRANSACTION_STATE.NONE) {
      return;
    } else if (isRfpPending(transactionState)) {
      const interval = setInterval(() => {
        return dispatch(
          AppActions.transactionStatus(),
        );
      }, rfpStatusInterval);
      return () => clearInterval(interval);
    }
  }, [transactionState, dispatch])

  useEffect(() => {
    dispatch( AppActions.setRfpMonitoring());
  }, [dispatch])

  const selectBankImage = () => {
    switch (bankName) {
      case "boaImage":
        return boaImage;
      case "capitalOneImage":
        return capitalOneImage;
      case "chaseImage":
        return chaseImage;
      case "citiImage":
        return citiImage;
      case "pncImage":
        return pncImage;
      case "tdImagege":
        return tdImage;
      case "usBankImagege":
        return usBankImage;
      case "wellsFargoImage":
        return wellsFargoImage;
      default:
        return genericImage;
    }
  };

  const rotatingMessages = [
    <>Your <b>${transactionAmount} {transactionType}</b> to {merchantName} needs to be approved <b>within your bank's app.</b></>,
    <>You should receive the <b>notification</b> on your <b>mobile phone</b> within 30 seconds.</>,
    <>From time to time, we ask for approval on deposits for <b>security purposes.</b></>,
    <>If you don't receive the notification, log in to your <b>bank's app</b> to approve the <b>Request for Payment.</b></>,
    <><b>Thanks</b> for your patience as we verify your account.</>,
  ];

  const openInfoDrawer = () => {
    setShowInfoDrawer(true);
  };
  const closeInfoDrawer = () => {
    setShowInfoDrawer(false);
  };

  return (
    <PageWrapper>
      <ApprovalBody>APPROVAL REQUIRED:</ApprovalBody>
      <InstructionsContainer>
        <InstructionsBody>
          Tap on the notification from your bank to complete the deposit
        </InstructionsBody>
        <InstructionsIcon src={greenAlertIcon} onClick={openInfoDrawer} />
      </InstructionsContainer>
      <BankImage src={selectBankImage()} />
      <Fader rotatingMessages={rotatingMessages} />
      <FooterWrapper>
        <StyledBodyLoadingSpin>
          <StyledSpinIcon src={spinIcon} />
        </StyledBodyLoadingSpin>
        <ReturnText>You will return to {merchantName} once we receive your bank's confirmation</ReturnText>
        <Footer />
      </FooterWrapper>
      <RFPInfoDrawer showInfoDrawer={showInfoDrawer} onClose={closeInfoDrawer} />
    </PageWrapper>
  );
};

RFPLitePage.propTypes = {};
RFPLitePage.defaultProps = {};

export default RFPLitePage;
